import { Field, Form, Formik, useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
import InputField from "../../../forms/input-field";
import { useDispatch } from "react-redux";
import {
  deleteUomGroupItemAction,
  uomDropDownAction,
  uomDropDownActionnew,
  uomGroupAddAction,
  uomGroupUpdateAction,
} from "../../../../redux/actions/settings-action";
import Select from "react-select";
import * as Yup from "yup";
import successToast from "../../../helper-components/success-toast";
import errorToast from "../../../helper-components/error-toast";
import KibabMenu from "../../../../assets/icons/kibab-menu";
import DeleteIcon from "../../../../assets/icons/delete-icon";

import AddButton, { DraftButton } from "../../../buttons/button";
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "none",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
};

const AddEditUom = ({ editingData, toogleChange, reload, onFormChange }) => {
  const itemTableHeaders = [
    "Pack Description",
    "Alt Qty",
    "Alt UOM",
    "Sub Qty",
    "Sub UOM",
    "Base Qty",
    "Base UOM",
    "",
  ];

  const packDescriptionOptions = [
    { label: "Primary", value: "primary" },
    { label: "Secondary", value: "secondary" },
    { label: "Tertiary", value: "tertiary" },
  ];

  const newLine = {
    alt_quantity: "",
    alt_uom: "",
    sub_quantity: "",
    sub_uom: "",
    base_quantity: "",
    base_uom_id: editingData?.group_items?.[0]?.base_uom_id ?? "",
    pack_description: "",
  };

  const initialValues = {
    group_id: editingData?.group_id || "",
    group_code: editingData?.group_code || "",
    name: editingData?.name || "",
    description: editingData?.description || "",
    group_items: editingData?.group_items || [],
  };

  const [uomLists, setUomLists] = useState([]);
  const [selectedDOtIndex, setSelectedDOtIndex] = useState(null);
  const [forceUpdate, setForceUpdate] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(uomDropDownActionnew({}, onSuccessUsers, onErrorUsers));
  }, [dispatch]);

  useEffect(() => {
    const element = document.querySelector(".innerLayoutScroller");
    if (element && element.style.overflow === "auto") {
      element.style.overflow = "hidden";
    }
  }, []);

  // Trigger calculations when group_items change
  useEffect(() => {
    if (editingData?.group_items && editingData.group_items.length > 1) {
      // This will trigger when editing existing data
      console.log("Triggering calculations on mount for editing data");
    }
  }, [editingData]);

  const onSuccessUsers = (data) => {
    setUomLists(
      data?.data?.map((item) => ({
        label: item?.name,
        value: item?.uom_id,
      }))
    );
  };

  const onErrorUsers = (data) => { };

  // Function to get available sub UOM options based on pack description
  const getSubUomOptions = (packDescription, groupItems) => {
    if (packDescription === "secondary") {
      // For secondary, show primary items as options
      const primaryItems = groupItems.filter(
        (item) => item.pack_description === "primary"
      );
      return primaryItems.map((item) => ({
        label: item.alt_uom,
        value: item.alt_uom,
      }));
    } else if (packDescription === "tertiary") {
      // For tertiary, show secondary items as options
      const secondaryItems = groupItems.filter(
        (item) => item.pack_description === "secondary"
      );
      return secondaryItems.map((item) => ({
        label: item.alt_uom,
        value: item.alt_uom,
      }));
    }
    return [];
  };

  // Function to check if sub UOM should be dropdown or text field
  const shouldUseDropdown = (packDescription, groupItems) => {
    if (packDescription === "secondary") {
      const primaryItems = groupItems.filter(
        (item) => item.pack_description === "primary"
      );
      return primaryItems.length > 1;
    } else if (packDescription === "tertiary") {
      const secondaryItems = groupItems.filter(
        (item) => item.pack_description === "secondary"
      );
      return secondaryItems.length > 1;
    }
    return false; // Primary always uses text field
  };

  // Function to get default sub UOM based on pack description
  const getDefaultSubUom = (packDescription, groupItems) => {
    if (packDescription === "secondary") {
      const primaryItems = groupItems.filter(
        (item) => item.pack_description === "primary"
      );
      return primaryItems.length > 0 ? primaryItems[0].alt_uom : "";
    } else if (packDescription === "tertiary") {
      const secondaryItems = groupItems.filter(
        (item) => item.pack_description === "secondary"
      );
      return secondaryItems.length > 0 ? secondaryItems[0].alt_uom : "";
    }
    return "";
  };

  // Function to auto-fill sub UOM based on pack description
  const getAutoFilledSubUom = (packDescription, groupItems) => {
    if (packDescription === "secondary") {
      const primaryItems = groupItems.filter(
        (item) => item.pack_description === "primary"
      );
      return primaryItems.length === 1 ? primaryItems[0].alt_uom : "";
    } else if (packDescription === "tertiary") {
      const secondaryItems = groupItems.filter(
        (item) => item.pack_description === "secondary"
      );
      return secondaryItems.length === 1 ? secondaryItems[0].alt_uom : "";
    }
    return "";
  };

  // Function to calculate base quantities on frontend
  const calculateBaseQuantities = (groupItems) => {
    if (groupItems.length < 2) return groupItems;

    const updatedItems = [...groupItems];

    // Find items by pack description
    const primaryItems = updatedItems.filter(
      (item) => item.pack_description === "primary"
    );
    const secondaryItems = updatedItems.filter(
      (item) => item.pack_description === "secondary"
    );
    const tertiaryItems = updatedItems.filter(
      (item) => item.pack_description === "tertiary"
    );

    console.log("Starting calculation with:", {
      primaryItems: primaryItems.map((p) => ({
        alt_uom: p.alt_uom,
        base_quantity: p.base_quantity,
        sub_quantity: p.sub_quantity,
      })),
      secondaryItems: secondaryItems.map((s) => ({
        alt_uom: s.alt_uom,
        sub_uom: s.sub_uom,
        sub_quantity: s.sub_quantity,
        base_quantity: s.base_quantity,
      })),
    });

    // Calculate for secondary items
    secondaryItems.forEach((secondaryItem) => {
      const secondaryIndex = updatedItems.findIndex(
        (item) => item === secondaryItem
      );
      if (secondaryIndex !== -1) {
        const subQty = parseFloat(secondaryItem.sub_quantity) || 0;

        // Find all matching primaries
        const matchingPrimaries = primaryItems.filter(
          (primary) => primary.alt_uom === secondaryItem.sub_uom
        );

        console.log("Found matching primaries for sub_uom:", {
          sub_uom: secondaryItem.sub_uom,
          matches: matchingPrimaries.map((p) => ({
            alt_uom: p.alt_uom,
            base_quantity: p.base_quantity,
          })),
        });

        if (matchingPrimaries.length > 0) {
          // If multiple primaries match, use the one with the highest base quantity
          const matchingPrimary = matchingPrimaries.reduce(
            (highest, current) => {
              const currentBaseQty = parseFloat(current.base_quantity) || 0;
              const highestBaseQty = parseFloat(highest.base_quantity) || 0;
              return currentBaseQty > highestBaseQty ? current : highest;
            },
            matchingPrimaries[0]
          );

          const primaryBaseQty = parseFloat(matchingPrimary.base_quantity) || 0;
          const calculatedBaseQty = subQty * primaryBaseQty;

          console.log(`Secondary calculation for index ${secondaryIndex}:`, {
            subQty,
            primaryBaseQty,
            calculatedBaseQty,
            matchingPrimary: matchingPrimary.alt_uom,
            totalMatches: matchingPrimaries.length,
            selected: matchingPrimary.base_quantity,
          });

          // Update the base quantity
          updatedItems[secondaryIndex] = {
            ...updatedItems[secondaryIndex],
            base_quantity: calculatedBaseQty.toString(),
          };
        } else {
          console.log(
            `No matching primary found for sub_uom: ${secondaryItem.sub_uom}`
          );
        }
      }
    });

    // Calculate for tertiary items
    tertiaryItems.forEach((tertiaryItem) => {
      const tertiaryIndex = updatedItems.findIndex(
        (item) => item === tertiaryItem
      );
      if (tertiaryIndex !== -1) {
        const subQty = parseFloat(tertiaryItem.sub_quantity) || 0;

        // Find all matching secondaries
        const matchingSecondaries = secondaryItems.filter(
          (secondary) => secondary.alt_uom === tertiaryItem.sub_uom
        );

        console.log("Found matching secondaries for sub_uom:", {
          sub_uom: tertiaryItem.sub_uom,
          matches: matchingSecondaries.map((s) => ({
            alt_uom: s.alt_uom,
            base_quantity: s.base_quantity,
          })),
        });

        if (matchingSecondaries.length > 0) {
          // If multiple secondaries match, use the one with the highest base quantity
          const matchingSecondary = matchingSecondaries.reduce(
            (highest, current) => {
              const currentBaseQty = parseFloat(current.base_quantity) || 0;
              const highestBaseQty = parseFloat(highest.base_quantity) || 0;
              return currentBaseQty > highestBaseQty ? current : highest;
            },
            matchingSecondaries[0]
          );

          const secondaryBaseQty =
            parseFloat(matchingSecondary.base_quantity) || 0;
          const calculatedBaseQty = subQty * secondaryBaseQty;

          console.log(`Tertiary calculation for index ${tertiaryIndex}:`, {
            subQty,
            secondaryBaseQty,
            calculatedBaseQty,
            matchingSecondary: matchingSecondary.alt_uom,
            totalMatches: matchingSecondaries.length,
            selected: matchingSecondary.base_quantity,
          });

          // Update the base quantity
          updatedItems[tertiaryIndex] = {
            ...updatedItems[tertiaryIndex],
            base_quantity: calculatedBaseQty.toString(),
          };
        } else {
          console.log(
            `No matching secondary found for sub_uom: ${tertiaryItem.sub_uom}`
          );
        }
      }
    });

    console.log(
      "Final calculated items:",
      updatedItems.map((item) => ({
        pack_description: item.pack_description,
        alt_uom: item.alt_uom,
        sub_uom: item.sub_uom,
        sub_quantity: item.sub_quantity,
        base_quantity: item.base_quantity,
      }))
    );

    return updatedItems;
  };

  const handleFieldChange = (field, value, setFieldValue, values) => {
    setFieldValue(`newLine.${field}`, value);

    if (
      values.newLine.alt_quantity &&
      values.newLine.alt_uom &&
      values.newLine.base_quantity &&
      values.newLine.base_uom_id
    ) {
      const groupItems = [...values.group_items];
      const { base_uom_id, ...rest } = values.newLine;
      rest.base_uom_id = base_uom_id.value;
      groupItems.push(rest);

      setFieldValue("group_items", groupItems);
      setFieldValue("newLine", {
        alt_quantity: "",
        alt_uom: "",
        base_quantity: "",
        base_uom_id: "",
      });
    }
  };

  // Function to handle field changes and trigger calculations
  const handleItemFieldChange = (
    field,
    value,
    subIndex,
    setFieldValue,
    values
  ) => {
    console.log(`Field ${field} changing to:`, value);

    // Create a copy of the current items
    const updatedItems = [...values.group_items];
    updatedItems[subIndex] = { ...updatedItems[subIndex], [field]: value };

    // If this is a field that affects calculations, update base quantities
    if (
      field === "sub_quantity" ||
      field === "sub_uom" ||
      field === "alt_quantity" ||
      field === "alt_uom" ||
      field === "base_quantity"
    ) {
      // Check if this is a base_quantity change that affects other items
      if (field === "base_quantity") {
        const changedItem = updatedItems[subIndex];
        const affectedItems = updatedItems.filter(
          (item) =>
            item.sub_uom === changedItem.alt_uom && // Item uses changed item's alt_uom as its sub_uom
            ((changedItem.pack_description === "primary" &&
              item.pack_description === "secondary") ||
              (changedItem.pack_description === "secondary" &&
                item.pack_description === "tertiary"))
        );

        if (affectedItems.length > 0) {
          console.log("Base quantity change affects items:", affectedItems);
        }
      }

      console.log("Calculating with items:", updatedItems);
      const calculatedItems = calculateBaseQuantities(updatedItems);
      console.log("Calculation result:", calculatedItems);
      setFieldValue("group_items", calculatedItems);
    } else {
      // Just update the single field
      setFieldValue("group_items", updatedItems);
    }
  };

  // const onSubmit = (values) => {
  //   if (values.group_id) {
  //     const updatedGroupItems = values.group_items.map((item) => {
  //       const { base_uom, ...rest } = item;
  //       return rest;
  //     });
  //     const dispatchingValues = {
  //       group_id: values?.group_id,
  //       name: values.name,
  //       description: values.description,
  //       group_items: updatedGroupItems,
  //     };

  //     dispatch(
  //       uomGroupUpdateAction(dispatchingValues, onAddSuccess, onAddError)
  //     );
  //   } else {
  //     values.group_items = [...values.group_items];
  //     const updatedGroupItems = values.group_items.map((item) => {
  //       const { base_uom, ...rest } = item;
  //       rest.base_uom_id = rest?.base_uom_id?.value || rest.base_uom_id;
  //       return rest;
  //     });
  //     const dispatchingValues = {
  //       name: values.name,
  //       description: values.description,
  //       group_items: updatedGroupItems,
  //     };

  //     dispatch(uomGroupAddAction(dispatchingValues, onAddSuccess, onAddError));
  //   }
  // };

  // const onSubmit = (values) => {
  //   const updatedGroupItems = values.group_items.map(({ base_uom, ...rest }) => ({
  //     ...rest,
  //     base_uom_id: rest?.base_uom_id?.value || rest.base_uom_id,
  //   }));

  //   const dispatchingValues = {
  //     group_id: values.group_id,
  //     name: values.name,
  //     description: values.description,
  //     group_items: updatedGroupItems,
  //   };

  //   const action = values.group_id
  //     ? uomGroupUpdateAction(dispatchingValues, onAddSuccess, onAddError)
  //     : uomGroupAddAction(dispatchingValues, onAddSuccess, onAddError);

  //   dispatch(action);
  // };

  const onSubmit = (values) => {
    if (!values.group_items || values.group_items.length === 0) {
      errorToast("Group items must contain at least one item.");
      return;
    }
    const invalidItem = values.group_items.some((item) => {
      return (
        item.alt_quantity === "" ||
        item.alt_uom === "" ||
        item.base_quantity === "" ||
        !item.base_uom_id
      );
    });

    if (invalidItem) {
      errorToast("UOM must have Alt Qty, Alt UOM, Base Qty and Base UOM");
      return;
    }

    // Check for duplicate rows
    const duplicateRows = [];
    for (let i = 0; i < values.group_items.length; i++) {
      for (let j = i + 1; j < values.group_items.length; j++) {
        const item1 = values.group_items[i];
        const item2 = values.group_items[j];

        // Check if all fields are identical
        if (
          item1.alt_quantity === item2.alt_quantity &&
          item1.alt_uom === item2.alt_uom &&
          item1.sub_quantity === item2.sub_quantity &&
          item1.sub_uom === item2.sub_uom &&
          item1.base_quantity === item2.base_quantity &&
          item1.base_uom_id === item2.base_uom_id &&
          item1.pack_description === item2.pack_description
        ) {
          duplicateRows.push({ row1: i + 1, row2: j + 1 });
        }
      }
    }

    if (duplicateRows.length > 0) {
      const duplicateMessage = duplicateRows
        .map(({ row1, row2 }) => `Row ${row1} and Row ${row2}`)
        .join(", ");
      errorToast(`Duplicate rows found: ${duplicateMessage}. Please ensure all rows have unique data.`);
      return;
    }

    // Trigger final calculation before saving
    const finalGroupItems = calculateBaseQuantities(values.group_items);

    const updatedGroupItems = finalGroupItems.map((item, index) => {
      const { base_uom, ...rest } = item;
      const updatedItem = {
        ...rest,
        base_uom_id: rest?.base_uom_id?.value || rest.base_uom_id,
      };

      // Add sub_uom_id for the first row
      if (index === 0 && rest.sub_uom) {
        const subUomOption = uomLists.find((uom) => uom.label === rest.sub_uom);
        if (subUomOption) {
          updatedItem.sub_uom_id = subUomOption.value;
        }
      }

      return updatedItem;
    });

    const dispatchingValues = {
      group_id: values.group_id,
      name: values.name,
      description: values.description,
      group_code: values.group_code,
      group_items: updatedGroupItems,
    };

    console.log("Final data being sent:", dispatchingValues);
    console.log("First row sub_uom_id:", updatedGroupItems[0]?.sub_uom_id);

    const action = values.group_id
      ? uomGroupUpdateAction(dispatchingValues, onAddSuccess, onAddError)
      : uomGroupAddAction(dispatchingValues, onAddSuccess, onAddError);

    dispatch(action);
  };

  const onAddSuccess = (data) => {
    toogleChange();
    successToast(data?.message);
  };
  const onAddError = (data) => {
    errorToast(data?.data?.message);
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setSelectedDOtIndex(null);
    }
  };

  const onClickDelete = (item_id) => {
    dispatch(deleteUomGroupItemAction({ item_id }, onDelSuccess, onDelError));
  };

  const onDelSuccess = (data) => {
    setSelectedDOtIndex(null);
    reload();
    toogleChange();
    successToast(data?.message);
  };
  const onDelError = (data) => {
    setSelectedDOtIndex(null);
    errorToast(data?.data?.message);
  };

  // Component to track form changes
  const FormChangeTracker = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      if (onFormChange) {
        const hasChanges =
          JSON.stringify(initialValues) !== JSON.stringify(values);
        onFormChange(hasChanges);
      }
    }, [values, initialValues, onFormChange]);

    return null;
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ values, setFieldValue, dirty, handleSubmit }) => {
        return (
          <Form className="h-full flex flex-col justify-between">
            <FormChangeTracker />
            <div className="overflow-y-auto pl-5" onClick={handleClickOutside}>
              <div className="flex gap-12">
                <div style={{ maxWidth: "18rem" }} className="w-full">
                  <InputField
                    maxLength={20}
                    isDisabled={false}
                    containerClass="mt-1"
                    isRequired={true}
                    type="text"
                    name="name"
                    placeholder="Name"
                    label="Name"
                    labelWidth="5rem"
                  />
                </div>
                <div style={{ maxWidth: "28rem" }} className="w-full">
                  <InputField
                    maxLength={10}
                    isDisabled={false}
                    containerClass="mt-1"
                    isRequired={true}
                    type="text"
                    name="group_code"
                    placeholder="Code"
                    label="Code"
                    labelWidth="7rem"
                  />
                </div>
                <div style={{ maxWidth: "28rem" }} className="w-full">
                  <InputField
                    maxLength={255}
                    isDisabled={false}
                    containerClass="mt-1"
                    isRequired={false}
                    type="text"
                    name="description"
                    placeholder="Description"
                    label="Description"
                    labelWidth="7rem"
                  />
                </div>
              </div>
              <div className="w-full pt-2" style={{ height: "70vh" }}>
                <table className="w-full" key={forceUpdate}>
                  <thead>
                    <tr>
                      {itemTableHeaders.map((header, index) => (
                        <th
                          className="table-cell-billing my-2 whitespace-nowrap text-sm fw_700 text-475467 bg-F2F4F5 text-start p-2 w-24"
                          key={index}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {values.group_items.map((subItem, subIndex) => (
                      <tr key={subIndex}>
                        <td className="table-cell-billing text-sm fw_400 text-secondary p-2 w-32">
                          <Select
                            className="w-full"
                            options={packDescriptionOptions}
                            name={`group_items[${subIndex}].pack_description`}
                            id={`group_items[${subIndex}].pack_description`}
                            placeholder="Select"
                            value={
                              packDescriptionOptions.find(
                                (option) =>
                                  option.value ===
                                  values.group_items[subIndex].pack_description
                              ) || null
                            }
                            onChange={(option) => {
                              const newValue = option?.value || "";
                              console.log(
                                "Pack description changing to:",
                                newValue
                              );

                              // Create a copy of current items
                              const updatedItems = [...values.group_items];

                              // Update pack description
                              updatedItems[subIndex] = {
                                ...updatedItems[subIndex],
                                pack_description: newValue,
                              };

                              // Set default sub UOM based on pack description
                              const defaultSubUom = getDefaultSubUom(
                                newValue,
                                updatedItems
                              );
                              updatedItems[subIndex].sub_uom = defaultSubUom;

                              console.log(
                                "Updating with pack description change:",
                                {
                                  index: subIndex,
                                  newDescription: newValue,
                                  defaultSubUom,
                                  item: updatedItems[subIndex],
                                }
                              );

                              // Calculate with updated values
                              const calculatedItems =
                                calculateBaseQuantities(updatedItems);

                              // Update form with all changes
                              setFieldValue("group_items", calculatedItems);
                            }}
                            styles={{
                              ...customStyles,
                              control: (provided, state) => ({
                                ...provided,
                                border: "1px solid #e5e7eb",
                                borderRadius: "8px",
                                backgroundColor:
                                  values.group_items[subIndex]
                                    .pack_description === "primary"
                                    ? "#ffffff"
                                    : values.group_items[subIndex]
                                      .pack_description === "secondary"
                                      ? "#f3f4f6"
                                      : values.group_items[subIndex]
                                        .pack_description === "tertiary"
                                        ? "#f3f4f6"
                                        : "#ffffff",
                                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                "&:hover": {
                                  borderColor: "#d1d5db",
                                },
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isSelected
                                  ? "#e5ecffb2"
                                  : state.isFocused
                                    ? "#f3f4f6"
                                    : "#ffffff",
                                color: "#000000",
                                "&:hover": {
                                  backgroundColor: state.isSelected
                                    ? "#e5ecffb2"
                                    : "#f3f4f6",
                                },
                              }),
                            }}
                          />
                        </td>
                        <td className="table-cell-billing text-sm fw_400 text-secondary p-2 w-20">
                          <div className="flex items-center justify-center">
                            <div className="bg-[var(--pill-badge-blue-bg)] text-white rounded-full min-w-8 w-fit h-8 flex items-center justify-center text-sm font-medium">
                              <Field
                                min={0}
                                name={`group_items[${subIndex}].alt_quantity`}
                                placeholder="00"
                                type="number"
                                className="border-0 focus:outline-none focus:ring-0 text-center w-6 text-white text-sm font-medium [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                autoFocus
                                style={{ backgroundColor: "transparent" }}
                                disabled={
                                  !values.group_items[subIndex].pack_description
                                }
                                onKeyDown={(e) => {
                                  // Prevent minus, plus, 'e', 'E', and decimal point
                                  if (
                                    ["-", "+", "e", "E", "."].includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const value = Math.max(
                                    0,
                                    parseFloat(e.target.value) || 0
                                  );
                                  handleItemFieldChange(
                                    "alt_quantity",
                                    value,
                                    subIndex,
                                    setFieldValue,
                                    values
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="table-cell-billing text-sm fw_400 text-secondary p-2 w-24">
                          <Field
                            name={`group_items[${subIndex}].alt_uom`}
                            placeholder="Alt UOM"
                            className="border-0 focus:outline-none focus:ring-0 bg-transparent w-full py-1"
                            style={{ backgroundColor: "transparent" }}
                            disabled={
                              !values.group_items[subIndex].pack_description
                            }
                            onChange={(e) =>
                              handleItemFieldChange(
                                "alt_uom",
                                e.target.value,
                                subIndex,
                                setFieldValue,
                                values
                              )
                            }
                          />
                        </td>
                        <td className="table-cell-billing text-sm fw_400 text-secondary p-2 w-24">
                          <div className="flex items-center gap-2">
                            <span className="text-gray-600 font-medium text-lg">
                              =
                            </span>
                            <div className="bg-[var(--pill-badge-green-bg)] text-white rounded-full px-3 py-1 flex items-center justify-center min-w-[2rem]">
                              <Field
                                name={`group_items[${subIndex}].sub_quantity`}
                                placeholder="00"
                                type="number"
                                className="border-0 focus:outline-none focus:ring-0 bg-transparent text-center w-8 text-white text-sm font-medium [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                style={{ backgroundColor: "transparent" }}
                                disabled={
                                  !values.group_items[subIndex].pack_description
                                }
                                onKeyDown={(e) => {
                                  // Prevent minus, plus, 'e', 'E', and decimal point
                                  if (
                                    ["-", "+", "e", "E", "."].includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) =>
                                  handleItemFieldChange(
                                    "sub_quantity",
                                    e.target.value,
                                    subIndex,
                                    setFieldValue,
                                    values
                                  )
                                }
                              />
                            </div>
                          </div>
                        </td>
                        <td className="table-cell-billing text-sm fw_400 text-secondary p-2 w-24">
                          {values.group_items[subIndex].pack_description ===
                            "primary" ? (
                            <Field
                              name={`group_items[${subIndex}].sub_uom`}
                              placeholder="Sub UOM"
                              className="border-0 focus:outline-none focus:ring-0 bg-transparent w-full py-1"
                              style={{ backgroundColor: "transparent" }}
                              onChange={(e) =>
                                handleItemFieldChange(
                                  "sub_uom",
                                  e.target.value,
                                  subIndex,
                                  setFieldValue,
                                  values
                                )
                              }
                            />
                          ) : values.group_items[subIndex].pack_description ===
                            "secondary" ||
                            values.group_items[subIndex].pack_description ===
                            "tertiary" ? (
                            shouldUseDropdown(
                              values.group_items[subIndex].pack_description,
                              values.group_items
                            ) ? (
                              <Select
                                className="w-full"
                                options={getSubUomOptions(
                                  values.group_items[subIndex].pack_description,
                                  values.group_items
                                )}
                                name={`group_items[${subIndex}].sub_uom`}
                                id={`group_items[${subIndex}].sub_uom`}
                                placeholder="Select"
                                value={
                                  getSubUomOptions(
                                    values.group_items[subIndex]
                                      .pack_description,
                                    values.group_items
                                  ).find(
                                    (option) =>
                                      option.value ===
                                      values.group_items[subIndex].sub_uom
                                  ) || {
                                    value: values.group_items[subIndex].sub_uom,
                                    label: values.group_items[subIndex].sub_uom,
                                  }
                                }
                                onChange={(option) => {
                                  const newValue = option?.value || "";
                                  console.log("Sub UOM changing to:", newValue);

                                  // Create a copy of current items
                                  const updatedItems = [...values.group_items];
                                  updatedItems[subIndex] = {
                                    ...updatedItems[subIndex],
                                    sub_uom: newValue,
                                  };

                                  // Calculate with the updated sub_uom
                                  console.log(
                                    "Calculating with updated sub_uom:",
                                    updatedItems
                                  );
                                  const calculatedItems =
                                    calculateBaseQuantities(updatedItems);
                                  console.log(
                                    "Calculation result:",
                                    calculatedItems
                                  );

                                  // Update the form with calculated values
                                  setFieldValue("group_items", calculatedItems);
                                }}
                                styles={customStyles}
                              />
                            ) : (
                              <Field
                                name={`group_items[${subIndex}].sub_uom`}
                                placeholder="Sub UOM"
                                className="border-0 focus:outline-none focus:ring-0 bg-transparent w-full py-1"
                                style={{ backgroundColor: "transparent" }}
                                value={
                                  values.group_items[subIndex].sub_uom ||
                                  getDefaultSubUom(
                                    values.group_items[subIndex]
                                      .pack_description,
                                    values.group_items
                                  )
                                }
                                disabled
                              />
                            )
                          ) : (
                            <Field
                              name={`group_items[${subIndex}].sub_uom`}
                              placeholder="Sub UOM"
                              className="border-0 focus:outline-none focus:ring-0 bg-transparent w-full py-1"
                              style={{ backgroundColor: "transparent" }}
                              value={values.group_items[subIndex].sub_uom || ""}
                              disabled
                            />
                          )}
                        </td>
                        <td className="table-cell-billing text-sm fw_400 text-secondary p-2 w-24">
                          <div className="flex items-center gap-2">
                            <span className="text-gray-600 font-medium text-lg">
                              =
                            </span>
                            <div className="bg-[var(--pill-badge-d-voilet-bg)] text-white rounded-full px-3 py-1 flex items-center justify-center min-w-[2rem]">
                              <Field
                                name={`group_items[${subIndex}].base_quantity`}
                                type="number"
                                placeholder="00"
                                className="border-0 focus:outline-none focus:ring-0 bg-transparent text-center w-8 text-white text-sm font-medium [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                style={{ backgroundColor: "transparent" }}
                                disabled={
                                  values.group_items[subIndex]
                                    .pack_description !== "primary" ||
                                  !values.group_items[subIndex].pack_description
                                }
                                onKeyDown={(e) => {
                                  // Prevent minus, plus, 'e', 'E', and decimal point
                                  if (
                                    ["-", "+", "e", "E", "."].includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) =>
                                  handleItemFieldChange(
                                    "base_quantity",
                                    e.target.value,
                                    subIndex,
                                    setFieldValue,
                                    values
                                  )
                                }
                              />
                            </div>
                          </div>
                        </td>
                        <td className="table-cell-billing text-sm fw_400 text-secondary p-2 w-24">
                          <Select
                            isDisabled={
                              values.group_items[subIndex].pack_description !==
                              "primary" ||
                              !values.group_items[subIndex].pack_description
                            }
                            className="w-full"
                            options={uomLists}
                            name={`group_items[${subIndex}].base_uom_id`}
                            id={`group_items[${subIndex}].base_uom_id`}
                            placeholder="Select"
                            value={
                              uomLists.find(
                                (option) =>
                                  option.value ===
                                  values.group_items[subIndex].base_uom_id
                              ) || null
                            }
                            onChange={(option) => {
                              const newValue = option?.value || "";
                              console.log("Base UOM changing to:", newValue);

                              // Update base_uom_id for this primary item only
                              setFieldValue(
                                `group_items[${subIndex}].base_uom_id`,
                                newValue
                              );
                            }}
                            styles={customStyles}
                          />
                        </td>
                        <td className="table-cell-billing text-sm fw_400 text-secondary p-2 w-16">
                          <div className="flex items-center justify-center">
                            <button
                              className="p-1 hover:bg-gray-100 rounded"
                              onClick={() => {
                                const updatedData = [...values.group_items];
                                updatedData.splice(subIndex, 1);
                                setFieldValue("group_items", updatedData);
                                dispatch(deleteUomGroupItemAction({ item_id: values.group_items[subIndex].item_id }, onDelSuccess, onDelError));
                              }}
                              type="button"
                              title="Delete"
                            >
                              <DeleteIcon
                                width="14"
                                height="14"
                                fill="#F24E1E"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {/* <tr>
                          <td
                            className={`table-cell-billing text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.alt_quantity"
                              placeholder="Alt quantity"
                              type="number"
                              value={values.newLine.alt_quantity}
                              onChange={(e) =>
                                handleFieldChange(
                                  "alt_quantity",
                                  e.target.value,
                                  setFieldValue,
                                  values
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                              autoFocus
                            />
                          </td>
                          <td
                            className={`table-cell-billing text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.alt_uom"
                              placeholder="Alt UOM"
                              value={values.newLine.alt_uom}
                              onChange={(e) =>
                                handleFieldChange(
                                  "alt_uom",
                                  e.target.value,
                                  setFieldValue,
                                  values
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                            />
                          </td>
                          <td
                            className={`table-cell-billing text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.base_quantity"
                              type="number"
                              placeholder="Base quantity"
                              value={values.newLine.base_quantity}
                              onChange={(e) =>
                                handleFieldChange(
                                  "base_quantity",
                                  e.target.value,
                                  setFieldValue,
                                  values
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                            />
                          </td>
                          <td
                            style={{ width: "15rem", minWidth: "11rem" }}
                            className={`table-cell-billing text-sm fw_400 text-secondary`}
                          >
                            <Select
                              options={uomLists}
                              name="newLine.base_uom_id"
                              placeholder="Select a base UOM"
                              value={values.newLine.base_uom_id}
                              onChange={(option) =>
                                handleFieldChange(
                                  "base_uom_id",
                                  option,
                                  setFieldValue,
                                  values
                                )
                              }
                              styles={customStyles}
                            />
                          </td>
                          <td
                            className={`table-cell-billing text-sm fw_400 text-secondary`}
                          ></td>
                        </tr> */}
                  </tbody>
                </table>

                <div className="flex justify-between w-full items-center">
                  <div className="text-sm text-gray-600">
                    <button
                      type="button"
                      onClick={() => {
                        console.log(
                          "Manual calculation trigger with current values:",
                          values.group_items
                        );
                        const updatedItems = calculateBaseQuantities(
                          values.group_items
                        );
                        console.log("Manual calculation result:", updatedItems);
                        setFieldValue("group_items", updatedItems);
                      }}
                      className="bg-blue-500 text-white px-4 py-1 rounded text-xs"
                    >
                      Recalculate Base Qty
                    </button>
                  </div>
                  <AddButton
                    className="bg-primary text-white px-8 py-1 mt-2 rounded flex justify-center fw_500 text-sm"
                    onclkFn={() => {
                      const newItem = {
                        alt_quantity: "",
                        alt_uom: "",
                        sub_quantity: "",
                        sub_uom: "",
                        base_quantity: "",
                        base_uom_id:
                          values?.group_items?.[0]?.base_uom_id ?? "",
                        pack_description: "",
                      };

                      const updatedItems = [...values?.group_items, newItem];
                      setFieldValue(`group_items`, updatedItems);
                    }}
                    prefixIcon={true}
                    text=""
                    type="button"
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-between w-full invoice-bottom-container py-4 px-4 items-center">
              <DraftButton onclkFn={toogleChange} text="Cancel" />
              <AddButton
                isDisabled={!dirty}
                onclkFn={() => handleSubmit()}
                prefixIcon={false}
                text="Save"
                type="button"
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddEditUom;
